module.exports = __webpack_public_path__ + "static/img/1ortho4.5850046d.png";